class collectionQuickFilter extends HTMLElement {
  static observedAttributes = ["data-current-url"];
  constructor() {
    super();
    this.container = document.getElementById('ProductGridContainer');
    this.categories = this.querySelectorAll('[data-category-url]');
    this.categoriesContainer = this.querySelector('.categories');
    this.statusRegion = document.querySelector('.category-status');
    this.setUrl();
  }

  get currentUrl () {
    return this.dataset.currentUrl;
  }

  connectedCallback() {
    window.addEventListener('popstate', () => {
      this.isPopstate = true;
      this.dataset.currentUrl = document.location.pathname + document.location.search;
    });

    this.categoriesContainer.addEventListener('scroll', ()=> {
      this.handleScroll();
    })
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-current-url' && newValue !== oldValue) {
      if (oldValue === null) {
        this.setActiveState();
        return;
      }
      this.setActiveState();
      this.renderCollection();
    }
  }

  setUrl() {
    if(this.container && this.categories.length > 0) {
      this.categories.forEach(category => {
        category.addEventListener('click', ()=> {
          const url = category.dataset.categoryUrl;
          if (this.getPathname(this.dataset.currentUrl) === this.getPathname(url)) {
            this.dataset.currentUrl = this.dataset.parentUrl;
          } else {
            this.dataset.currentUrl = url;
          }
        })
      })
    }
  }

  setActiveState () {
    if(this.container && this.categories.length > 0) {
      this.categories.forEach(category => {        
        if (this.getPathname(this.currentUrl) === this.getPathname(category.dataset.categoryUrl)) {
          category.classList.add('active');
          category.classList.remove('button-outline');
          category.classList.add('button-solid');
        } else {
          category.classList.remove('active');
          category.classList.remove('button-solid');
          category.classList.add('button-outline');
        }
      })
    }
  }

  getPathname(url) {
    return new URL(url, window.location.origin).pathname;
  }

  async renderCollection() {
    if (this.currentUrl !== '') {
      const sectionId = this.dataset.sectionId;
      const separator = this.currentUrl.includes('?') ? '&' : '?';
      const fetchUrl = sectionId
        ? `${this.currentUrl}${separator}sections=${sectionId}`
        : this.currentUrl;

      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) return;

        let collectionGrid;
        if (sectionId) {
          const json = await response.json();
          const sectionHtml = json[sectionId];
          if (!sectionHtml) return;
          const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
          collectionGrid = html.getElementById('ProductGridContainer');
        } else {
          const result = await response.text();
          const html = new DOMParser().parseFromString(result, 'text/html');
          collectionGrid = html.getElementById('ProductGridContainer');
        }

        if (collectionGrid && this.container) {
          this.container.innerHTML = collectionGrid.innerHTML;
          if (!this.isPopstate) {
            history.pushState({}, '', this.currentUrl);
          }
          this.isPopstate = false;
        }
      } catch (e) {
        console.error('Quick filter: failed to load collection', e);
      }
    }
  }

  handleScroll() {
    const scrollEnd = this.categoriesContainer.scrollWidth - this.categoriesContainer.clientWidth;
    if(this.categoriesContainer.scrollLeft === 0) {
      this.classList.add('on-start');
      this.classList.remove('scrolling');
      this.classList.remove('on-end');
    } else if (this.categoriesContainer.scrollLeft > 10 && this.categoriesContainer.scrollLeft < scrollEnd - 10) {
      this.classList.remove('on-start');
      this.classList.add('scrolling');
      this.classList.remove('on-end');
    } else if (this.categoriesContainer.scrollLeft >= scrollEnd - 10){
      this.classList.remove('on-start');
      this.classList.remove('scrolling');
      this.classList.add('on-end');
    }
  }
}

if (!customElements.get('collection-quick-filter')) {
customElements.define('collection-quick-filter', collectionQuickFilter)
}
